import { ValidatorFn, AbstractControl } from '@angular/forms';

export const CustomRegExp = (exp: any): ValidatorFn => {
  const expSplit = exp.split('@:@');
  const pattern = expSplit[0];
  const flags = expSplit[1] ? expSplit[1] : '';
  const regExp = new RegExp(pattern, flags);
  const filed = expSplit[2] ? expSplit[2] : 'filed';
  const message = `This ${filed} does not match the format.`;

  return (control: AbstractControl): any => {

    if (!control.value) {
      return null;
    }
    const valid = regExp.test(control.value);
    if ( valid === true ) {
      return null;
    } else {
      return {
        invalidRegExp: true,
        message: message
      };
    }

  };

};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/reg-exp/reg-exp.validator.ts